import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { useCustomerStore } from "~/stores/customer";
import { useNavigation } from "~/composables/use-navigation";
import { useAuthRedirect } from "~/composables/use-auth-redirect";
import { usePinia } from "#imports";

export default defineNuxtRouteMiddleware((to) => {
  const { resolvePath } = useNavigation();
  const pinia = usePinia();
  const customer = useCustomerStore(pinia);

  if (customer.isLogged) {
    return;
  }

  const { persist } = useAuthRedirect();
  persist(to.fullPath);

  return navigateTo(resolvePath("auth", {}), {
    replace: true,
    redirectCode: 401,
  });
});
